<template>		

	<span class="d-flex justify-content-between align-items-end">
		<div class="input-date-container">
			<the-mask type="tel" :mask="['mM/dD/####']" :masked="true" :tokens="mask_tokens" v-model="date_text" @change.native="dateTextChanged"/>
			<i class="fa fa-times clear-date" v-show="date_text != ''" @click="clearDate"></i>
		</div>
		<i class="fa fa-calendar ml-2" :id="'popover-' + _uid"></i>

		<!-- try with popover -->
		<b-popover :target="'popover-' + _uid" title="Select a date" triggers="click" placement="top">

			<!--
			<ul class="no-style">
				<li>
					<button type="button" class="button" @click="today">Today</button>
				</li>
				<li>
					<button type="button" class="button" @click="thisWeek">This week</button>
				</li>
				<li>
					<button type="button" class="button" @click="thisMonth">This month</button>
				</li>
			</ul>
			-->
			<div class="d-flex">
	   			<div class="input-content mr-2">
	   				<label>Month</label>
	   				<v-select :options="months" track-by="id" label="value" v-model="month">
					</v-select>
	   			</div>
	   			<div class="input-content mr-2">
	   				<label>Day</label>
	   				<v-select :options="days" track-by="id" label="value" v-model="day"></v-select>
	   			</div>
	   			<div class="input-content">
	   				<label>Year</label>
	   				<v-select :options="years" track-by="id" label="value" v-model="year"></v-select>
	   			</div>

	   			
	   		</div>
	   		<div class="error-msg text-right" v-show="show_max_error">{{ checkMax }}</div>
   			<div class="error-msg text-right" v-show="show_min_error">{{ checkMin }}</div>

	   		<div class="text-right">
		   		<button type="button" @click="cancel" class="button dark-gray-content">Cancel</button>

		   		<button type="button" @click="ok" class="button" :class="{ 'disabled-button' : !can_ok }" :disabled="!can_ok">Ok</button>
		   	</div>
		</b-popover>
	</span>
</template>

<script>

	import { EventBus } from './../../../event_bus.js';
	import { TheMask } from 'vue-the-mask'
	export default{
		components : {
			TheMask
		},
		props : [
			'value',
			'default',
			'min',
			'max'
		],

		watch : {
			
			month : function(month, old_month){

				if(month){
					//populate days select
					var n_days = month.n_days;

					this.days =[];

					for(var i=1; i<=n_days; i++){

						/*console.log(typeof(this.max), typeof(this.min));
						if(this.max !== undefined && typeof(this.max) == 'object'){

							if(this.max.day <= i){
								this.days.push({
									id : i.toString().padStart(2, '0'),
									value : i.toString().padStart(2, '0')
								});
							}

							
						}else if(this.min !== undefined && typeof(this.min == 'object')){
							if(this.min.day >= i){
								this.days.push({
									id : i.toString().padStart(2, '0'),
									value : i.toString().padStart(2, '0')
								});
							}
						}else{*/
							this.days.push({
								id : i.toString().padStart(2, '0'),
								value : i.toString().padStart(2, '0')
							});
						//}
						
					}
				}
				
			}
		},

		computed : {
			checkMax : function(){				
				if(this.max !== undefined && typeof(this.max) == 'object'){

					if(this.year && this.month && this.day){
						var date = new Date(this.max.year + '/' +this.max.month + '/' + this.max.day);
						var date_selected = new Date(this.year.id + '/' + this.month.id + '/' + this.day.id );

						if(date_selected > date){
							this.show_max_error = true;
							this.can_ok = false;
						}else{
							this.show_max_error = false;
							this.can_ok = true;
						}
					}

					return 'The date should be less than ' + this.max.month + '/' + this.max.day + '/' + this.max.year;					
				}
			},

			checkMin : function(){
				if(this.min !== undefined && typeof(this.min) == 'object'){

					if(this.year && this.month && this.day){
						var date = new Date(this.min.year + '/' +this.min.month + '/' + this.min.day);
						var date_selected = new Date(this.year.id + '/' + this.month.id + '/' + this.day.id );

						if(date_selected < date){
							this.show_min_error = true;
							this.can_ok = false;
						}else{
							this.show_min_error = false;
							this.can_ok = true;
						}
					}

					return 'The date should be greater than ' + this.min.month + '/' + this.min.day + '/' + this.min.year;					
				}
			}
		},
		data : function(){
			return {
				mask_tokens : {
					'm' : {
			          pattern : /[0-1]/
			        },
			        'M' : {
			          pattern : /[0-9]/
			        },
			        'd' : {
			          pattern : /[0-3]/
			        },
			        'D' : {
			          pattern : /[0-9]/
			        },
			        '#': {pattern: /\d/}
				},
				n_years : 50,
				initial_months : [
					{ id : '01', value : 'January', n_days : 31 },
					{ id : '02', value : 'February', n_days : 28 },
					{ id : '03', value : 'March', n_days : 31 },
					{ id : '04', value : 'April', n_days : 30 },
					{ id : '05', value : 'May', n_days : 31 },
					{ id : '06', value : 'June', n_days : 30 },
					{ id : '07', value : 'July', n_days : 31 },
					{ id : '08', value : 'August', n_days : 31 },
					{ id : '09', value : 'September', n_days : 30 },
					{ id : '10', value : 'October', n_days : 31 },
					{ id : '11', value : 'November', n_days : 30 },
					{ id : '12', value : 'December', n_days : 31 }
				],
				months : [],
				days : [],
				years : [],
				date_text : '',
				show_modal : false,
				day : null,
				month : null,
				year : null,
				show_max_error : false,
				show_min_error : false,
				can_ok : true
			}
		},
		created : function(){

			if(typeof(this.value) == 'object'){
				this.date_text = this.value.month + '/' + this.value.day + '/' + this.value.year;
			}

			this.setDefault();
			this.iniYearSelect();

			this.months = this.initial_months;
			EventBus.$on('CLEAR_DATEPICKER_TEXT', () => {
				this.day = null;
				this.month = null;
				this.year = null;
				this.date_text = '';
			});

			this.$root.$on('bv::popover::show', bvEventObj => {
				var id = bvEventObj.target.getAttribute('id');

				if(id == 'popover-' + this._uid){		

					/*if(this.max !== undefined && typeof(this.max) == 'object'){
						
						var max_year = this.max.year;
						var max_month = this.max.month;
						var max_day = this.max.day;

						//ini year
						var start_year = parseInt(new Date().getFullYear());

						this.years = [];

						for(var i=0; i<this.n_years; i++){
							if(start_year - i <= max_year){
								this.years.push({
									id : (start_year-i).toString(),
									value: (start_year-i).toString()
								});
							}							
						}

						//set available months
						this.months = [];

						for(var i in this.initial_months){

							if(parseInt(this.initial_months[i].id) >= max_month){
								this.months.push(this.initial_months[i]);
							}
						}

						//set available days
						this.days = [];
					}

					if(this.min !== undefined && typeof(this.min) == 'object'){
						var min_year = this.min.year;
						var min_month = this.min.month;
						var min_day = this.min.day;

						//ini year
						var start_year = parseInt(new Date().getFullYear());

						this.years = [];

						for(var i=0; i<this.n_years; i++){
							if(start_year - i >= min_year){
								this.years.push({
									id : (start_year-i).toString(),
									value: (start_year-i).toString()
								});
							}							
						}

						//set available months
						this.months = [];

						for(var i in this.initial_months){

							if(parseInt(this.initial_months[i].id) <= min_month){
								this.months.push(this.initial_months[i]);
							}
						}

						//set available days
						this.days = [];
					}*/
				}
		    })

		},
		methods : {

			iniYearSelect : function(){
				var start_year = parseInt(new Date().getFullYear());

				for(var i=0; i<this.n_years; i++){
					this.years.push({
						id : (start_year-i).toString(),
						value: (start_year-i).toString()
					});
				}
			},

			//TODO - INPUT VALIDATION
			dateTextChanged : function(){

				//update the selects month/day/year

				if(this.date_text.length == 10){
					var parts = this.date_text.split('/');

					for(var i in this.months){
						if(this.months[i].id == parts[0].toString().padStart(2, '0')){
							this.month = this.months[i];
							break;
						}
					}

					this.day = {
						id : parts[1].toString().padStart(2, '0'),
						value : parts[1].toString().padStart(2, '0'),
					}

					this.year = {
						id : parts[2],
						value : parts[2]
					}
					this.updateValue();
				}else{
					this.date_text = '';
				}
				
			},

			updateValue : function(){


				if(this.date_text != ''){
					var parts = this.date_text.split('/');
					var day = 0;
					var month = 0;
					var year = 0;

					for(var i in this.months){
						if(this.months[i].id == parts[0].toString().padStart(2, '0')){
							month = this.months[i].id;
							break;
						}
					}

					day = parts[1].toString().padStart(2, '0');
					year = parts[2];

					this.$emit('input', {
						day : day,
						month : month,
						year : year
					})
				}else{

					this.$emit('input', '');
				}
				
			},

			ok : function(){

				//set the month/day/year in date_text			

				this.date_text = this.month.id + '/' + this.day.id + '/' + this.year.id;

				this.closePopover();
				this.updateValue();
			},

			cancel : function(){
				this.closePopover();
			},

			closePopover : function(){
				this.$root.$emit('bv::hide::popover', 'popover-' + this._uid);

				//update v-model
				this.updateValue();
			},

			clearDate : function(){
				this.date_text = '';
				this.day = null;
				this.month = null;
				this.year = null;

				this.updateValue();
			},

			today : function(){
				
				var today_info = this.getTodayInfo();

				this.year = today_info.year;
				this.month = today_info.month;
				this.day = today_info.day;

				this.ok();

			},

			thisWeek : function(){
				var today_info = this.getTodayInfo();

				this.year = today_info.year;
				this.month = today_info.month;
				this.day = today_info.first_day_of_the_week;


				this.ok();
			},

			thisMonth : function(){

			},

			getTodayInfo : function(){
				var today = new Date();

				var year = {
					id : today.getFullYear(),
					value : today.getFullYear()
				};

				var month = (today.getMonth() +1).toString().padStart(2, '0');

				for(var i in this.months){
					if(this.months[i].id == month){
						month = this.months[i];
						break;
					}
				}

				var day = {
					id : (today.getDate()).toString().padStart(2, '0'),
					value : (today.getDate()).toString().padStart(2, '0')
				}

				var week_day = today.getDay() -1;

				var first_day_of_the_week = {
					id : (today.getDate() - week_day).toString().padStart(2, '0'),
					value : (today.getDate() - week_day).toString().padStart(2, '0')
				}

				return {
					today : today,
					year : year,
					month : month,
					day : day,
					first_day_of_the_week : first_day_of_the_week
				}

			},

			setDefault : function(){
				if(this.default == 'today'){
					this.today();
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/shared/inputs/DatePickerTextComponent.vue